/** Realm-Rollen für Up2Boat Admin – aligned mit Backend u2b-admin/routes.ts */
export function canAccessU2bAdminArea(realmGroups: string[] | undefined | null): boolean {
    const roles = realmGroups || [];
    return roles.includes('u2b_super_admin')
        || roles.includes('u2b_admin')
        || roles.includes('u2b_support')
        || roles.includes('u2b_bcm_admin')
        || roles.includes('u2b_bcm_editor')
        || roles.includes('u2b_bcm_support');
}

/** RetailForce-TSE-Stammdaten schreiben/testen – nur BCM-Admin (+ Super-Admin). */
export function canWriteAdminTseIntegration(realmGroups: string[] | undefined | null): boolean {
    const roles = realmGroups || [];
    return roles.includes('u2b_super_admin')
        || roles.includes('u2b_bcm_admin');
}

/** Plesk-Backup, Abo-Scheduler und globaler Event-Planer schalten – nur BCM-Admin (+ Super-Admin), wie im Backend. */
export function canWriteAdminTenantInfrastructure(realmGroups: string[] | undefined | null): boolean {
    return canWriteAdminTseIntegration(realmGroups);
}
